import { HttpMethod } from "../components/Common/useFetch";
import { RequestOptions } from "../components/Common/useRequest";
import useUserRequest from "../components/Common/useUserRequest";
import { useSelectedBusiness } from "../components/UserAccess/useSelectedBusiness";

const useFetchTransportsFromTmx = (siteId: string, options?: RequestOptions<{ notificationId: string }>) => {
  const business = useSelectedBusiness();
  return useUserRequest<void, { notificationId: string }>({
    path: `/api/businesses/${business.id}/transports/sync/fetch?siteId=${siteId}`,
    method: HttpMethod.POST,
  }, options);
}

export default useFetchTransportsFromTmx;
